import { ReactNode, useState } from 'react';

import { Button } from 'antd';
import cs from 'classnames';

import { ReactComponent as ArrowUp } from 'assets/icons/arrowUp.svg';

import styles from './ReadMore.module.scss';

interface ReadMoreProps {
  openedText: string;
  closedText: string;
  children: ReactNode | null;
}

const ReadMore = ({
  openedText,
  closedText,
  children
}: ReadMoreProps): ReactNode => {
  const [opened, setOpened] = useState(false);

  const toggleOpen = () => {
    setOpened((prev) => !prev);
  };

  return (
    <div className={styles.readMoreContainer}>
      {opened && children}
      <Button
        className={styles.button}
        icon={
          <div className={cs(styles.iconWrapper, { [styles.closed]: !opened })}>
            <ArrowUp className={cs({ [styles.iconClosed]: !opened })} />
          </div>
        }
        iconPosition="end"
        type="link"
        onClick={toggleOpen}
      >
        {opened ? openedText : closedText}
      </Button>
    </div>
  );
};

export default ReadMore;
